import { Environment } from '../types/environment';
import { recordmodApi } from '../utils/axios';

export const getCurrentEnvironment = async () => {
  const { data } = await recordmodApi.get<Environment>('/api/env');
  return data;
};
